<div class="h-full" #chartOutput>
	@if (loading()) {
		<span class="block w-full mt-40 text-center text-lg">Loading timing data...</span>
	}
</div>
